module.exports = __webpack_public_path__ + "static/media/Socialpiper-boostingpower-mobile-esp.a7bf6a5e.png";